export const LABEL_MANAGEMENT_STORE_LABELS = {
	FETCH_LABELS_FAILED: 'Failed to load labels'
} as const;
